var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7961 36.3021C7.98425 36.3021 0 28.2975 0 18.4606C0 8.62373 7.98425 0.619141 17.7961 0.619141C27.608 0.619141 35.5923 8.62373 35.5923 18.4606C35.5923 28.2975 27.6152 36.3021 17.7961 36.3021ZM17.7961 1.27302C8.34261 1.27302 0.645047 8.983 0.645047 18.4678C0.645047 27.9454 8.33545 35.6626 17.7961 35.6626C27.2497 35.6626 34.9472 27.9526 34.9472 18.4678C34.9472 8.983 27.2568 1.27302 17.7961 1.27302Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1577 16.3264L14.1048 8.85352H11.0229V28.0674H14.1048L17.4591 23.3753H14.1048V13.3013L16.1762 16.3264H19.1577Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4414 20.5945L21.4943 28.0674H24.5762V8.85352H21.4943L18.14 13.5528H21.4943V23.6196L19.423 20.5945H16.4414Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e2e94d0ed22a404b27dc8cd137eab779.svg";
export { ForwardRef as ReactComponent };